import { IStateActionList, IStateSetup, IStateSetupChecks, IStateSetupStepWifi, IStateSetupStepDns, IStateSetupStepPort, IStateSetupStepGeolocation, IStateSetupSummary, IStateSetupStepEnrollMobile, IStateAdminStatus, IStatePurchaseList, IStateDeviceList, IStateMasterDevice, IStateApplicationList, IStateUserList, IStateSetupStepLdapConfig, IStateSimpleConfig } from 'store/store.model';

export const account = {
  user: {
    userName: '',
    firstName: '',
    lastName: '',
    email: '',
    validated: false,
    twoFactor: false,
    id: 0,
    token: '',
    level: 0,
    devices: [],
    password: '',
    passwordCheck: ''
  },
  twoFactor: {
    authenticatorUri: '',
    code: '',
    sharedKey: '',
    show: false,
    error: '',
    success: ''
  },
  saveData: {
    location: null,
    job: null
  },
  errors: [],
  success: ''
}

export const login = {
  userName: "",
  password: "",
  token: "",
  twoFactor: false,
  error: ''
}

export const itemManagement = {
  item: {
    id: 0
  },
  items: []
}
export const passwordRequest = {
  email: '',
  validated: false,
  error: '',
  success: ''
}

export const setupStepDns: IStateSetupStepDns = {
  domainName: '',
  validated: false,
  domainNameReserved: false,
  domainNameConfirmed: false
}

export const setupStepPort: IStateSetupStepPort = {
  httpsPort: 5000,
  validated: false
}

export const setupStepEnrollMobile: IStateSetupStepEnrollMobile = {
  internationalPhoneNumber: "",
  phoneNumber: '',
  name: '',
  countryCode: '',
  hash: '',
  isEnrolled: false,
  isSecondFormVisible: false,
  validated: false
}

export const setupStepGeolocation: IStateSetupStepGeolocation = {
  latitude: '',
  longitude: '',
  address: '',
  zipCode: '',
  city: '',
  country: '',
  ip: '',
  ipv6: '',
  internetIp: '',
  validated: false,
}

export const setupStepWifi: IStateSetupStepWifi = {
  wifiSSID: '',
  wifiConnectionType: '',
  wifiPassword: '',
  validated: false,
}

export const setupLdapConfig: IStateSetupStepLdapConfig = {
  type: 'auto',
  humanDomainName: '',
  systemDomainName: '',
  administrator : '',
  password: '',
  validated: false,
}

export const setupSummary: IStateSetupSummary = {
  userRegistered: false,
  error: '',
  success: ''
}

export const setupChecks: IStateSetupChecks = {
  welcomeChoice: "empty",
  hasPrimaryAccount: false,
  dnsIsConfirmed: false,
  geolocationIsConfirmed: false,
  ldapConfigIsConfirmed: false,
  portIsConfirmed: false,
  phoneIsConfirmed: false,
  dnsIsValidated: false,
  geolocationIsValidated: false,
  ldapConfigIsValidated: false,
  portIsValidated: false,
  phoneIsValidated: false,
  installationIsConfirmed: false,
  isWaiting: true,
  isMasterAvailable: true,
  isMaster: true,
  ean: "noSetYet"
}

export const setupCanBeSimple: IStateSimpleConfig = { 
  administrator: [],
  dns: [],
  geoLocation: [],
  ldap: [],
  port: [],
  phone: [],
  canBeSimple: false,
  error: ''
}

export const setup: IStateSetup = {
  checks: setupChecks,
  stepLdapConfig: setupLdapConfig,
  stepDns: setupStepDns,
  stepGeolocation: setupStepGeolocation,
  stepPort: setupStepPort,
  stepWifi: setupStepWifi,
  stepEnrollMobile: setupStepEnrollMobile,
  summary: setupSummary,
  canBeSimple: setupCanBeSimple,
  isInstalling: false,
  isMaster: true,
  submit: "pending"
}

export const applicationList: IStateApplicationList = {
  total: 0,
  result: []
}

export const usersList: IStateUserList = {
  total: 0,
  result: []
}

export const purchases = {
  applications: []
}

export const purchaseList: IStatePurchaseList = {
  total: 0,
  result: []
}

export const deviceList: IStateDeviceList = {
  total:0,
  result: []
}

export const statusGeolocation: IStateSetupStepGeolocation = {
  latitude: '',
  longitude: '',
  address: '',
  zipCode: '',
  city: '',
  country: '',
  ip: '',
  ipv6: '',
  internetIp: '',
  validated: false
}

export const deviceStatus: IStateMasterDevice = {
  totalSpace: 100,
  usedSpace: 50
}

export const adminStatus: IStateAdminStatus = {
  statusCode: 500,
  errorDescription: 'information not retrieved yet',
  services: [],
  chunks: { isEncrypted: 0, isExtracted: 0, isInCloud: 0, total: 0 },
  items: { isProcessed: 0, isInCloud: 0, total: 0 },
  geolocation: statusGeolocation,
  purchases: purchaseList,
  devices: deviceList,
  deviceStatus: deviceStatus
}

export const actions: IStateActionList = {
  total: 0,
  result: []
}

// TODO hériter de IState
const intialState = {
  actions: actions,
  login: login,
  adminStatus: adminStatus,
  itemManagement: itemManagement,
  passwordRequest: passwordRequest,
  setup: setup,
  account: account,
  applications: applicationList,
  purchases: purchaseList,
  users: usersList,
  language: "fr"
};

export default intialState;
